export default __webpack_public_path__ + "static/media/tigerbox_touch_red.27297218.png";